import { Fragment } from 'react'

import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { useVendors } from '@/hooks/useVendors'
import { type ApplicationCarrier, CarrierStatus, carrierStatusLabels } from '@/models/internalApplication'

const STATUS_BADGES: Record<CarrierStatus, BadgeVariant> = {
  [CarrierStatus.PREPARING]: 'outline',
  [CarrierStatus.APPLICATION_SENT]: 'outline',
  [CarrierStatus.PRICED]: 'default',
  [CarrierStatus.REQUEST_TO_BIND]: 'default',
  [CarrierStatus.BOUND]: 'success',
  [CarrierStatus.DECLINED]: 'secondary',
  [CarrierStatus.UNAVAILABLE]: 'secondary',
  [CarrierStatus.ERROR]: 'destructive',
}

/** One line per carrier on an application, with how far it got. */
export function CarrierStatusList({ carriers }: { carriers: ApplicationCarrier[] }) {
  const { vendorLabel } = useVendors()

  if (!carriers.length) return <span className="text-muted-foreground">—</span>

  return (
    // Inline so a right-aligned table card field can align it; the grid lines the badges up.
    <dl className="inline-grid grid-cols-[max-content_max-content] items-center gap-x-3 gap-y-1 text-left text-sm">
      {carriers.map(({ vendor, status }) => (
        <Fragment key={vendor}>
          <dt>{vendorLabel(vendor)}</dt>
          <dd>
            <Badge variant={STATUS_BADGES[status]}>{carrierStatusLabels[status]}</Badge>
          </dd>
        </Fragment>
      ))}
    </dl>
  )
}
